"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var PopupItem = /** @class */ (function (_super) {
    __extends(PopupItem, _super);
    function PopupItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onClose = function () {
            _this.setState({ active: false });
        };
        _this.state = {
            active: false,
            cookieExpired: false
        };
        return _this;
    }
    PopupItem.prototype.componentDidMount = function () {
        var _this = this;
        var age = parseInt(this.props.block.settings.expires) * 3600 * 24;
        this.popupActive()
            ? setTimeout(function () {
                return _this.setState({
                    active: true,
                    cookieExpired: true
                });
            }, this.props.block.settings.delay)
            : null;
    };
    PopupItem.prototype.popupActive = function () {
        var _a = this.props.block.settings, location = _a.location, specifictemplate = _a.specifictemplate, specificurl = _a.specificurl;
        return (location == "all_pages" ||
            (location == "template" && this.props.data.template.name == specifictemplate) ||
            (location == "specific" && this.props.history.location.pathname == specificurl));
    };
    PopupItem.prototype.render = function () {
        var block = this.props.block;
        return block.settings.enable && this.state.active && this.state.cookieExpired ? (React.createElement("div", { className: "fixed min-h-51 pin-t m-auto items-center p-4 content-center justify-center bg-overlay w-full h-full-h flex:row " + (block.settings.hidemobile ? "hidden md:flex" : "flex"), style: { zIndex: 500 } },
            React.createElement("div", { className: "fixed pin bg-smoke-dark transition opacity-1 pointer-events-auto", onClick: this.onClose }),
            React.createElement("div", { className: "bg-arctic max-w-sm relative z-10 rounded shadow-box", style: {
                    width: block.settings.width + "px"
                } },
                React.createElement("div", { className: "flex w-full min-h-51" },
                    block.settings.image ? (React.createElement("div", { className: "w-1/2 bg-center bg-cover rounded-l hidden overflow-hidden relative md:block", style: { backgroundImage: "url('" + block.settings.image + ")" } },
                        React.createElement("div", { className: "cover-image rotate:45 w-1/4 bg-arctic absolute pin-y pin-r" }))) : null,
                    React.createElement("div", { className: "flex items-center md:w-1/2 py-6 pl-1-6 lg:pr-8 pr-1-6 flex-1 text-" + block.settings.alignment },
                        React.createElement("div", null,
                            React.createElement("a", { onClick: this.onClose, className: "absolute pin-t pin-r w-4-8 h-4-8 flex justify-center items-center text-navy-dark cursor-pointer z-50" },
                                React.createElement(Snippets.Svg, { name: "cross", width: 12 })),
                            block.settings.enablelogo ? React.createElement(Snippets.Logo, { reverse: true, className: "flex flex-grow text-left mb-1-6 ", width: 200 }) : null,
                            !block.settings.enablesubscribe ? (React.createElement("div", null,
                                React.createElement("h2", { className: "text-navy-dark text-xmd mb-1 font-semibold leading-tight" }, block.settings.title),
                                React.createElement("p", { className: "text-grey-dark font-normal text-base leading-ntight mb-2" }, block.settings.content))) : null,
                            block.settings.linkurl ? (React.createElement("div", { className: "mt-10" },
                                React.createElement("a", { href: block.settings.linkurl, className: "text-navy text-md" }, block.settings.linktext))) : null,
                            block.settings.enablesubscribe ? (React.createElement(Snippets.SubscribeForm, __assign({}, this.props, { enabled: true, className: "", title: block.settings.title, content: block.settings.content, sucsesstitle: block.settings.successtitle, sucsesscontent: block.settings.successcontent, shoplink: block.settings.shopurl }))) : null)))))) : null;
    };
    return PopupItem;
}(React.PureComponent));
exports.PopupItem = PopupItem;
